// extracted by mini-css-extract-plugin
module.exports = {"centered-container":"notFound_centered-container___zLh2","title":"notFound_title__kUQ7g"};